import { Component, Output, Input, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { FormBase } from '@core/_classes/form.base';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessagesService } from '@core/_services/messages.service';
import { AuthService } from '@auth/auth.service';
import { HeaderCustMenuBase } from '@pages/page-custmenu-base/header-custmenubase';
import { AutofocusDirective } from '@directives/auto-focus.directive';
import { Message } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-form-custmenubase',
    templateUrl: './form-custmenubase.component.html',
    styleUrls: ['./form-custmenubase.component.scss'],
    providers: [AutofocusDirective],
})
export class FormCustMenuBaseComponent extends FormBase implements OnInit, OnDestroy {
    public resultForm: FormGroup;
    public validClick = false;
    public isAdmin = false;
    public screenSelect = [];

    @Input()
    public dataItem: HeaderCustMenuBase = null;

    @Input()
    public screenList = [];

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter();

    protected screenInternalList = []

    constructor(
        private formBuilder: FormBuilder,
        private auth: AuthService,
        protected messageService: MessagesService,
        private translate: TranslateService
    ) {
        // Injection de messageService dans la classe mère
        super(messageService);

        this.isAdmin = this.auth.isAdmin();
        this.resultForm = this.formBuilder.group({
            id: null,
            name: [null, [Validators.required, Validators.minLength(1), Validators.maxLength(45)]],
            label: [null, [Validators.required, Validators.minLength(1), Validators.maxLength(45)]],
            desc: null,
            menuorder: null,
            menuitem: null
        });
        this.initialization();
    }

    ngOnInit() {
        this.screenInternalList = [...this.screenList];
        if (this.dataItem !== null && this.dataItem !== undefined) {
            this.dataItem.notifyParent.subscribe(success => {
                this.resultForm.patchValue(this.dataItem);
                if (this.dataItem.menuitem !== null) {
                    this.screenSelect = JSON.parse(this.dataItem.menuitem);

                    const screenSelectIds = new Set(this.screenSelect.map(item => item.value));
                    this.screenInternalList = this.screenInternalList.filter(screenItem =>
                        !screenSelectIds.has(screenItem.value));
                }
            })
        }
    }

    ngOnDestroy() {
        if (this.dataItem !== null && this.dataItem !== undefined) {        
            this.dataItem.notifyParent.unsubscribe();
        }
    }


    public moveToTarget($event) {

    }

    public moveToSource($event) {

    }

    public validate() {
        let wRequest: any;
        this.resultForm.value.menuitem = JSON.stringify(this.screenSelect);
        wRequest = new Object();
        wRequest = {
            data: this.resultForm.value,
        };
        this.validClick = true;
        const error: Array<Message> = [];
        if (this.resultForm.invalid) {
            this.getErrorsInputs(error, this.resultForm);
        } else {
            this.onValidate.emit(wRequest);
        }
    }

    public cancel() {
        this.validClick = false;
        this.onCancel.emit('cancel');
    }

    public deleteItem() {
        this.onDelete.emit(this.resultForm.value);
    }

    private initialization() {
        this.keys = {
            name: {
                label: this.translate.instant('Tag_Name'),
                pattern: '',
            },
            label: {
                label: this.translate.instant('Tag_Lab'),
                pattern: '',
            },
        };
    }
}
